export default __webpack_public_path__ + "static/media/6.7b1f7ad9.jpeg";